import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsOptional, IsString, ValidateNested } from 'class-validator';
import { SubdivisionSupervisorBatchInterface } from '../interfaces/subdivision-supervisor-batch.interface';
import { SubdivisionSupervisorInterface } from '../interfaces/subdivision-supervisor.interface';
import { SubdivisionSupervisorCreateDto } from './subdivision-supervisor-create.dto';
import { SubdivisionSupervisorUpdateDto } from './subdivision-supervisor-update.dto';
import { SubdivisionSupervisorReplaceDto } from './subdivision-supervisor-replace.dto';

export class SubdivisionSupervisorBatchDto
  implements SubdivisionSupervisorBatchInterface
{
  @ApiPropertyOptional({
    type: () => SubdivisionSupervisorCreateDto,
    title: 'SubdivisionSupervisor',
    nullable: true,
    isArray: true,
    description: 'Insert bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => SubdivisionSupervisorCreateDto)
  insert!: SubdivisionSupervisorCreateDto[];

  @ApiPropertyOptional({
    type: () => SubdivisionSupervisorUpdateDto,
    title: 'SubdivisionSupervisor',
    nullable: true,
    isArray: true,
    description: 'Update bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => SubdivisionSupervisorUpdateDto)
  update!: SubdivisionSupervisorUpdateDto[];

  @ApiPropertyOptional({
    type: () => SubdivisionSupervisorReplaceDto,
    title: 'SubdivisionSupervisor',
    nullable: true,
    isArray: true,
    description: 'Replace bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => SubdivisionSupervisorReplaceDto)
  replace!: SubdivisionSupervisorReplaceDto[];

  @ApiProperty({
    type: () => String,
    nullable: true,
    isArray: true,
    title: 'Delete Bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  delete!: SubdivisionSupervisorInterface['id'][];
}
